import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'
import { Base } from './Base'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const Tags: React.FC<Props> = ({ coordinate }) => {
  return (
    <Base title="タグ">
      {coordinate.tags.map((tag) => (
        <li key={tag.id}>
          <Chip
            href={buildUrl({
              tagIds: [tag.id],
            })}
          >{`#${tag.name}`}</Chip>
        </li>
      ))}
    </Base>
  )
}
